export default {
  data() {
    return {
      passwordShown: 'false',
      passwordFieldType: 'password',
    };
  },
  computed: {
    showPasswordClass() {
      return this.passwordShown === true ? 'fa-eye-slash' : 'fa-eye';
    },
    showPasswordText() {
      return this.passwordShown === true ? 'Hide password' : 'Show password';
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.passwordShown = !this.passwordShown;
      if (this.passwordShown) {
        this.passwordFieldType = 'text';
      } else {
        this.passwordFieldType = 'password';
      }
    },
  },
};
